import { render } from "./ItemSlidingTutorial.vue?vue&type=template&id=1abc61ec&ts=true"
import script from "./ItemSlidingTutorial.vue?vue&type=script&lang=ts"
export * from "./ItemSlidingTutorial.vue?vue&type=script&lang=ts"

import "./ItemSlidingTutorial.vue?vue&type=style&index=0&id=1abc61ec&lang=scss"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__